import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Box, Typography, IconButton, Stack } from "@mui/material";
import { fetchLostLeads } from "../../services/lostLeadsApi";
import { useAppSelector } from "../../store/hook";
import moment from "moment";
import UpdateLostModal from "./UpdateLostModal";
import UpdateOnlineLeads from "../calls/updateOnlineLeads";
import { Note, StatusChange, SyncLead } from "../calls/Calls";
import { updateCallRecord } from "../../services/newdashboard";
import { toast } from "react-toastify";
import UpdateAcquisition from "../calls/updateAcquisition";
import UpdateCallLeads from "../calls/updateCallLeads";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import CommentModal from "./commentModal";

interface Props {
  isPrintMode: boolean;
  dateFilter: {
    startDate: string;
    endDate: string;
  };
  clinicData: string;
}

const renderSource = (
  source: string,
  hasRecording: boolean,
  leadId: number
) => {
  if (source === "Call") {
    return (
      <span>
        {" "}
        {hasRecording && (
          <span
            //   onClick={() => handleRecordingClick(leadId)}
            style={{
              cursor: hasRecording ? "pointer" : "default",
              display: "inline-block",
            }}
            title={hasRecording ? "Click to listen to recording" : ""}
          >
            {" "}
          </span>
        )}
      </span>
    );
  } else if (source === "Booking") {
    return <span> </span>;
  } else if (source === "Rewards") {
    return <span> </span>;
  } else if (source === "Referral") {
    return <span> </span>;
  }
  return source;
};

const LostLeadsSection = ({ isPrintMode, dateFilter, clinicData }: Props) => {
  const clinics = useAppSelector((state) => state.user.user.clinics);
  const clinicDatax = clinics?.find(
    (item: any) => item.uniqueId === clinicData
  );
  const [leads, setLeads] = useState<any[]>([]);
  const [acquisition, setAcquisition] = useState<any[]>([]);
  const [calls, setCalls] = useState<any[]>([]);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenAcquisition, setIsModalOpenAcquisition] = useState(false);
  // const [loading, setLoading] = useState(true);
  const [openUpdateLostModal, setOpenUpdateLostModal] = useState(false);
  const [selectedLostLead, setSelectedLostLead] = useState<any>(null);
  const [type, setType] = useState<"lead" | "acquisition" | "call" | "">(
    "lead"
  );
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [commentData, setCommentData] = useState<any>();

  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [showAcquisitionDialog, setShowAcquisitionDialog] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
  });

  const handleUpdateLost = (data: any) => {
    fetchLostLeadsData();
    setType("lead");
    setOpenUpdateLostModal(false);
  };

  const handleCloseUpdateLostModal = () => {
    setOpenUpdateLostModal(false);
  };
  const fetchLostLeadsData = async () => {
    setLoading(true);
    try {
      const response = await fetchLostLeads({
        clinicUniqueId: clinicData,
        startDate: dateFilter.startDate,
        endDate: dateFilter.endDate,
      });
      if (response?.status?.msg === "Success") {
        setLeads(
          response?.leads?.map((x: any, i: number) => ({
            ...x,
            name: `${x?.fname} ${x?.lname}`,
            srNo: i + 1,
            id: x?.id,
          }))
        );
        setAcquisition(
          response?.acquisition?.map((x: any, i: number) => ({
            ...x,
            name: `${x?.fname} ${x?.lname}`,
            srNo: i + 1,
            id: x?.id,
          }))
        );
        setCalls(
          response?.calls?.map((x: any, i: number) => ({
            ...x,
            srNo: i + 1,
            id: x?.id,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching lost leads:", error);
    } finally {
      setLoading(false);
    }
  };
  // Fetch lost leads data
  useEffect(() => {
    if (clinicData && dateFilter?.startDate && dateFilter?.endDate) {
      fetchLostLeadsData();
    }
  }, [dateFilter, clinicData]);

  const handleChange = (e: any) => {
    const newValue = e.target.value;
    setValue(newValue);
    if (newValue === "Acquisition") {
      setShowAcquisitionDialog(true);
      // setShowApprove(false);
      setValue("");
    } else if (newValue !== "") {
      // setShowApprove(true);
    } else {
      // setShowApprove(false);
    }
  };

  const handleAcquisitionSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await updateCallRecord(clinicData, selectedLostLead.id, {
        ...formData,
        status: "Acquisition",
      });
      if (res?.status?.msg === "Success") {
        setShowAcquisitionDialog(false);
        setOpenUpdateLostModal(false);
        toast.success("Updated successfully");
        setFormData({ firstName: "", lastName: "" });
      }
      if (fetchLostLeadsData) {
        await fetchLostLeadsData();
      }
    } catch (error) {
      console.error("Error submitting acquisition form:", error);
    } finally {
      setLoading(false);
    }
  };
  const reasonBodyTemplate = (row: any) => (
    <div
      style={{
        whiteSpace: "pre-wrap",
        wordWrap: "break-word",
        lineHeight: "1.5",
      }}
    >
      {row.notes}
    </div>
  );

  const actionBodyTemplate = (row: any) => (
    <div className="flex justify-center items-center h-full">
      <button
        onClick={(e) => {
          e.stopPropagation();
          setSelectedRow({ ...row, newStatus: row?.newStatus });
          setIsModalOpen(true);
        }}
        className="px-2 py-1 text-xs rounded bg-[#4CC9C0] text-white whitespace-nowrap min-w-[80px] hover:opacity-90"
      >
        📋 Update
      </button>
      <button
        onClick={(e) => {
          e.stopPropagation();
          setOpen1(true);
          setCommentData({
            ...row,
            ...row?.matchedPatient,
            comment: row?.comment,
          });
        }}
        className="px-2 text-xs rounded"
        // style={{
        //   padding: "2px 8px",
        //   marginTop: "10px",
        //   backgroundColor: "#E0E0E0",
        //   border: "none",
        // }}
      >
        <i className="bi bi-info-circle"></i>
      </button>
    </div>
  );

  const actionBodyTemplate2 = (row: any) => (
    <div className="flex justify-center items-center h-full">
      <button
        onClick={(e) => {
          setType("call");
          setSelectedLostLead(row);
          setOpenUpdateLostModal(true);
          setSelectedRow({ ...row, newStatus: row?.status });
          console.log(row);
        }}
        className="px-2 py-1 text-xs rounded bg-[#4CC9C0] text-white whitespace-nowrap min-w-[80px] hover:opacity-90"
      >
        📋 Update
      </button>
      <button
        onClick={(e) => {
          e.stopPropagation();
          setOpen2(true);
          setCommentData({
            ...row,
            ...row?.matchedPatient,
            comment: row?.comment,
          });
        }}
        className="px-2 text-xs rounded"
        // style={{
        //   padding: "2px 8px",
        //   marginTop: "10px",
        //   backgroundColor: "#E0E0E0",
        //   border: "none",
        // }}
      >
        <i className="bi bi-info-circle"></i>
      </button>
    </div>
  );

  const actionBodyTemplate3 = (row: any) => (
    <div className="flex justify-center items-center h-full">
      <button
        onClick={(e) => {
          e.stopPropagation();
          setSelectedRow({ ...row, newStatus: row?.status });
          setIsModalOpenAcquisition(true);
        }}
        className="px-2 py-1 text-xs rounded bg-[#4CC9C0] text-white whitespace-nowrap min-w-[80px] hover:opacity-90"
      >
        📋 Update
      </button>
      <button
        onClick={(e) => {
          e.stopPropagation();
          setOpen3(true);
          setCommentData({
            ...row,
            ...row?.matchedPatient,
            comment: row?.comment,
          });
        }}
        className="px-2 text-xs rounded"
        // style={{
        //   padding: "2px 8px",
        //   marginTop: "10px",
        //   backgroundColor: "#E0E0E0",
        //   border: "none",
        // }}
      >
        <i className="bi bi-info-circle"></i>
      </button>
    </div>
  );

  // const columns: Column[] = [
  //   {
  //     field: "srNo",
  //     headerName: "Sr No",
  //     width: 60,
  //     sortable: true,
  //     // For automatic serial number with pagination
  //     // renderCell: (_row, index) => index + 1,
  //   },
  //   {
  //     field: "name",
  //     headerName: "Name",
  //     minWidth: 140,
  //     sortable: true,
  //   },
  //   {
  //     field: "email",
  //     headerName: "Email",
  //     minWidth: 130,
  //     sortable: true,
  //   },
  //   {
  //     field: "source",
  //     headerName: "Source",
  //     minWidth: 120,
  //     sortable: true,
  //     renderCell: (row) => renderSource(row.source, row.hasRecording, row.id),
  //   },
  //   {
  //     field: "notes",
  //     headerName: "Reason",
  //     minWidth: 200,
  //     renderCell: (row) => (
  //       <div
  //         style={{
  //           whiteSpace: "pre-wrap",
  //           wordWrap: "break-word",
  //           width: "100%",
  //           padding: "8px 0",
  //           lineHeight: "1.5",
  //         }}
  //       >
  //         {row.notes}
  //       </div>
  //     ),
  //   },
  //   {
  //     field: "newStatus",
  //     headerName: "Status",
  //     minWidth: 130,
  //     sortable: true,
  //   },
  //   {
  //     field: "action",
  //     headerName: "Action",
  //     width: 120,
  //     sortable: false,
  //     renderCell: (row) => (
  //       <div className="flex justify-center items-center h-full">
  //         <button
  //           onClick={(e) => {
  //             e.stopPropagation();
  //             console.log(row, "rowxxxxxxxxxx");
  //             setSelectedRow({ ...row, newStatus: row?.status });
  //             setIsModalOpen(true);
  //           }}
  //           className="px-2 py-1 text-xs rounded bg-[#4CC9C0] text-white hover:opacity-90"
  //         >
  //           📋 Update
  //         </button>
  //       </div>
  //     ),
  //   },
  // ];

  // const callsColumns: Column[] = [
  //   {
  //     field: "srNo",
  //     headerName: "Sr No",
  //     width: 60,
  //     sortable: true,
  //   },
  //   {
  //     field: "customerNumber",
  //     headerName: "Phone",
  //     minWidth: 140,
  //     sortable: true,
  //   },
  //   {
  //     field: "source",
  //     headerName: "Source",
  //     minWidth: 120,
  //     renderCell: (row) => renderSource(row.source, row.hasRecording, row.id),
  //     sortable: true,
  //   },
  //   {
  //     field: "notes",
  //     headerName: "Reason",
  //     minWidth: 200,
  //     renderCell: (row) => (
  //       <div
  //         style={{
  //           whiteSpace: "pre-wrap",
  //           wordWrap: "break-word",
  //           width: "100%",
  //           padding: "8px 0",
  //           lineHeight: "1.5",
  //         }}
  //       >
  //         {row.notes}
  //       </div>
  //     ),
  //   },
  //   {
  //     field: "status",
  //     headerName: "Status",
  //     minWidth: 130,
  //     sortable: true,
  //   },
  //   {
  //     field: "actions",
  //     headerName: "Actions",
  //     width: 120,
  //     sortable: false,
  //     renderCell: (row) => (
  //       <button
  //         onClick={() => {
  //           setType("call");
  //           setSelectedLostLead(row);
  //           setOpenUpdateLostModal(true);
  //           setSelectedRow({ ...row, newStatus: row?.status });
  //           console.log(row);
  //         }}
  //         className="px-2 py-1 text-xs rounded bg-[#4CC9C0] text-white hover:opacity-90"
  //       >
  //         📋 Update
  //       </button>
  //     ),
  //   },
  // ];

  // const acquisitionColumns: Column[] = [
  //   {
  //     field: "srNo",
  //     headerName: "Sr No",
  //     width: 60,
  //     sortable: true, // optional
  //   },
  //   {
  //     field: "name",
  //     headerName: "Name",
  //     minWidth: 140,
  //     sortable: true,
  //   },
  //   {
  //     field: "email",
  //     headerName: "Email",
  //     minWidth: 130,
  //     sortable: true,
  //   },
  //   {
  //     field: "source",
  //     headerName: "Source",
  //     minWidth: 120,
  //     renderCell: (row) => renderSource(row.source, row.hasRecording, row.id),
  //     sortable: true,
  //   },
  //   {
  //     field: "notes",
  //     headerName: "Reason",
  //     minWidth: 200,
  //     renderCell: (row) => (
  //       <div
  //         style={{
  //           whiteSpace: "pre-wrap",
  //           wordWrap: "break-word",
  //           width: "100%",
  //           padding: "8px 0",
  //           lineHeight: "1.5",
  //         }}
  //       >
  //         {row.notes}
  //       </div>
  //     ),
  //   },
  //   {
  //     field: "status",
  //     headerName: "Status",
  //     minWidth: 130,
  //     sortable: true,
  //   },
  //   {
  //     field: "action",
  //     headerName: "Action",
  //     width: 120,
  //     sortable: false,
  //     renderCell: (row) => (
  //       <div className="flex justify-center gap-2">
  //         <button
  //           onClick={(e) => {
  //             e.stopPropagation();
  //             setSelectedRow({ ...row, newStatus: row?.status });
  //             setIsModalOpenAcquisition(true);
  //           }}
  //           className="px-2 py-1 text-xs rounded bg-[#4CC9C0] text-white hover:opacity-90"
  //         >
  //           📋 Update
  //         </button>
  //       </div>
  //     ),
  //   },
  // ];

  

  return (
    <>
      <Box
        sx={{ p: 4, backgroundColor: "white", borderRadius: 2, boxShadow: 2 }}
      >
        <Typography variant="h5" fontWeight="bold" color="#194e5b" gutterBottom>
          Lost Leads From Online Scheduling
        </Typography>
        <Typography fontWeight="bold" color="#194e5b" mb={2}>
          Lost Leads Details:{" "}
          <Box component="span" color="red" fontWeight="bold">
            {leads?.length}
          </Box>
        </Typography>

        <div style={{ width: "100%" }}>
          <DataTable
            value={leads}
            dataKey="id"
            size="large"
            showGridlines
            // stripedRows
            tableStyle={{ minWidth: "100%", borderCollapse: "collapse" }}
            className="custom-table"
          >
            {/* ✅ Sr No */}
            <Column
              field="srNo"
              header="Sr No"
              body={(_, options) => options.rowIndex + 1}
              style={{
                width: "5%",
                whiteSpace: "nowrap", // 🔹 prevents wrapping
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />

            {/* ✅ Name */}
            <Column
              field="name"
              header="Name"
              style={{ maxWidth: "100%", fontWeight: 500 }}
            />

            {/* ✅ Email */}
            <Column
              field="email"
              header="Email"
              style={{
                minWidth: "160px",
                maxWidth: "220px",
                whiteSpace: "nowrap", // 🔹 single line
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />

            {/* ✅ Source */}
            <Column
              field="source"
              header="Source"
              body={(row) => renderSource(row.source, row.hasRecording, row.id)}
              style={{ minWidth: "120px", textTransform: "capitalize" }}
            />

            {/* ✅ Reason */}
            <Column
              field="notes"
              header="Reason"
              // body={reasonBodyTemplate}
              style={{
                minWidth: "10%", // 🔹 reduced further
                maxWidth: "140px", // 🔹 tighter cap
                whiteSpace: "normal", // 🔹 Reason can wrap
                wordBreak: "break-word",
                lineHeight: "1.5",
              }}
            />

            {/* ✅ Status */}
            <Column
              field="newStatus"
              header="Status"
              style={{ minWidth: "130px" }}
            />

            {/* ✅ Action */}
            <Column
              header="Action"
              body={actionBodyTemplate}
              style={{ width: "10%", textAlign: "center" }}
            />
          </DataTable>

          {/* ✅ Custom Styles */}
          <style jsx global>{`
            .p-datatable.custom-table {
              border-radius: 10px;
              overflow: hidden;
              box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
              font-size: 14px;
            }

            .p-datatable.custom-table .p-datatable-thead > tr > th {
              background: #f9fafb;
              font-weight: 600;
              color: #111827;
              padding: 12px 16px;
              border-bottom: 1px solid #e5e7eb;
              white-space: nowrap;
              vertical-align: middle;
            }

            .p-datatable.custom-table .p-datatable-tbody > tr > td {
              padding: 12px 16px;
              border-bottom: 1px solid #e5e7eb;
              vertical-align: middle;
              white-space: normal;
              word-break: break-word;
            }

            .p-datatable.custom-table .p-datatable-tbody > tr:last-child > td {
              border-bottom: none;
            }

            .p-datatable-wrapper {
              overflow-x: hidden !important;
              overflow-y: hidden !important;
            }

            @media (max-width: 768px) {
              .p-datatable.custom-table {
                font-size: 12px;
              }
            }
          `}</style>
          {/* <DataTable
            columns={columns}
            rows={leads}
            // selectable
            // pagination
          /> */}
        </div>

        {/* Legend */}
        {/* <Box>
          <Typography fontWeight="bold">Legend:</Typography>
          <Stack
            direction="row"
            spacing={3}
            mt={1}
            alignItems="center"
            flexWrap="wrap"
          >
            {!isPrintMode && (
              <div style={{ fontSize: "0.85rem", marginTop: "0.5rem" }}>
                <strong>Legend:</strong>
                = Phone Call &nbsp;|&nbsp;
                <span style={{ cursor: "pointer" }}></span> = Recording
                Available (clickable) &nbsp;|&nbsp; = Online Booking
                &nbsp;|&nbsp; = Add/Edit Comment
              </div>
            )}
          </Stack>
        </Box> */}
      </Box>

      <Box
        sx={{
          p: 4,
          backgroundColor: "white",
          borderRadius: 2,
          boxShadow: 2,
          my: 2,
        }}
      >
        <Typography variant="h5" fontWeight="bold" color="#194e5b" gutterBottom>
          Lost Leads From Calls
        </Typography>
        <Typography fontWeight="bold" color="#194e5b" mb={2}>
          Calls Details:{" "}
          <Box component="span" color="red" fontWeight="bold">
            {calls?.length}
          </Box>
        </Typography>

        <div style={{ width: "100%" }}>
          <DataTable
            value={calls}
            dataKey="id"
            size="large"
            showGridlines
            // stripedRows
            tableStyle={{ minWidth: "100%", borderCollapse: "collapse" }}
            className="custom-table"
          >
            {/* ✅ Sr No */}
            <Column
              field="srNo"
              header="Sr No"
              body={(_, options) => options.rowIndex + 1}
              style={{
                width: "5%",
                whiteSpace: "nowrap", // 🔹 prevents wrapping
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />

            <Column
              field="customerNumber"
              header="Phone"
              style={{
                minWidth: "150px",
                maxWidth: "160px",
                whiteSpace: "nowrap", // 🔹 single line
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontWeight: 500,
              }}
            />

            {/* ✅ Source */}
            <Column
              field="source"
              header="Source"
              body={(row) => renderSource(row.source, row.hasRecording, row.id)}
              style={{ minWidth: "120px", textTransform: "capitalize" }}
            />

            {/* ✅ Reason */}
            <Column
              field="notes"
              header="Reason"
              // body={reasonBodyTemplate}
              style={{
                minWidth: "10%", // 🔹 reduced further
                maxWidth: "140px", // 🔹 tighter cap
                whiteSpace: "normal", // 🔹 Reason can wrap
                wordBreak: "break-word",
                lineHeight: "1.5",
              }}
            />

            {/* ✅ Status */}
            <Column
              field="status"
              header="Status"
              style={{ minWidth: "130px" }}
            />

            {/* ✅ Action */}
            <Column
              header="Action"
              body={actionBodyTemplate2}
              style={{ width: "10%", textAlign: "center" }}
            />
          </DataTable>

          {/* ✅ Custom Styles */}
          <style jsx global>{`
            .p-datatable.custom-table {
              border-radius: 10px;
              overflow: hidden;
              box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
              font-size: 14px;
            }

            .p-datatable.custom-table .p-datatable-thead > tr > th {
              background: #f9fafb;
              font-weight: 600;
              color: #111827;
              padding: 12px 16px;
              border-bottom: 1px solid #e5e7eb;
              white-space: nowrap;
              vertical-align: middle;
            }

            .p-datatable.custom-table .p-datatable-tbody > tr > td {
              padding: 12px 16px;
              border-bottom: 1px solid #e5e7eb;
              vertical-align: middle;
              white-space: normal;
              word-break: break-word;
            }

            .p-datatable.custom-table .p-datatable-tbody > tr:last-child > td {
              border-bottom: none;
            }

            .p-datatable-wrapper {
              overflow-x: hidden !important;
              overflow-y: hidden !important;
            }

            @media (max-width: 768px) {
              .p-datatable.custom-table {
                font-size: 12px;
              }
            }
          `}</style>
          {/* <DataTable
            columns={callsColumns}
            rows={calls}
            // selectable
            // pagination
          /> */}
        </div>

        {/* Legend */}
        {/* <Box>
          <Typography fontWeight="bold">Legend:</Typography>
          <Stack
            direction="row"
            spacing={3}
            mt={1}
            alignItems="center"
            flexWrap="wrap"
          >
            {!isPrintMode && (
              <div style={{ fontSize: "0.85rem", marginTop: "0.5rem" }}>
                <strong>Legend:</strong>
                = Phone Call &nbsp;|&nbsp;
                <span style={{ cursor: "pointer" }}></span> = Recording
                Available (clickable) &nbsp;|&nbsp; = Online Booking
                &nbsp;|&nbsp; = Add/Edit Comment
              </div>
            )}
          </Stack>
        </Box> */}
      </Box>
      <Box
        sx={{
          p: 4,
          backgroundColor: "white",
          borderRadius: 2,
          boxShadow: 2,
          my: 3,
        }}
      >
        <Typography variant="h5" fontWeight="bold" color="#194e5b" gutterBottom>
          Lost Leads Removed From Acquisition
        </Typography>
        <Typography fontWeight="bold" color="#194e5b" mb={2}>
          Acquisition Details:{" "}
          <Box component="span" color="red" fontWeight="bold">
            {acquisition?.length}
          </Box>
        </Typography>

        <div style={{ width: "100%" }}>
          <DataTable
            value={acquisition}
            dataKey="id"
            size="large"
            showGridlines
            // stripedRows
            tableStyle={{ minWidth: "100%", borderCollapse: "collapse" }}
            className="custom-table"
          >
            {/* ✅ Sr No */}
            <Column
              field="srNo"
              header="Sr No"
              body={(_, options) => options.rowIndex + 1}
              style={{
                width: "5%",
                whiteSpace: "nowrap", // 🔹 prevents wrapping
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />

            <Column
              field="name"
              header="Name"
              style={{ maxWidth: "100%", fontWeight: 500 }}
            />

            <Column
              field="email"
              header="Email"
              style={{
                minWidth: "160px",
                maxWidth: "220px",
                whiteSpace: "nowrap", // 🔹 single line
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />

            {/* ✅ Source */}
            <Column
              field="source"
              header="Source"
              body={(row) => renderSource(row.source, row.hasRecording, row.id)}
              style={{ minWidth: "120px", textTransform: "capitalize" }}
            />

            {/* ✅ Reason */}
            <Column
              field="notes"
              header="Reason"
              // body={reasonBodyTemplate}
              style={{
                minWidth: "10%", // 🔹 reduced further
                maxWidth: "140px", // 🔹 tighter cap
                whiteSpace: "normal", // 🔹 Reason can wrap
                wordBreak: "break-word",
                lineHeight: "1.5",
              }}
            />

            {/* ✅ Status */}
            <Column
              field="status"
              header="Status"
              style={{ minWidth: "130px" }}
            />

            {/* ✅ Action */}
            <Column
              header="Action"
              body={actionBodyTemplate3}
              style={{ width: "10%", textAlign: "center" }}
            />
          </DataTable>

          {/* ✅ Custom Styles */}
          <style jsx global>{`
            .p-datatable.custom-table {
              border-radius: 10px;
              overflow: hidden;
              box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
              font-size: 14px;
            }

            .p-datatable.custom-table .p-datatable-thead > tr > th {
              background: #f9fafb;
              font-weight: 600;
              color: #111827;
              padding: 12px 16px;
              border-bottom: 1px solid #e5e7eb;
              white-space: nowrap;
              vertical-align: middle;
            }

            .p-datatable.custom-table .p-datatable-tbody > tr > td {
              padding: 12px 16px;
              border-bottom: 1px solid #e5e7eb;
              vertical-align: middle;
              white-space: normal;
              word-break: break-word;
            }

            .p-datatable.custom-table .p-datatable-tbody > tr:last-child > td {
              border-bottom: none;
            }

            .p-datatable-wrapper {
              overflow-x: hidden !important;
              overflow-y: hidden !important;
            }

            @media (max-width: 768px) {
              .p-datatable.custom-table {
                font-size: 12px;
              }
            }
          `}</style>
          {/* <DataTable
            columns={acquisitionColumns}
            rows={acquisition}
            // selectable
            // pagination
          /> */}
          {/* <DataGrid
            hideFooter
            rows={acquisition}
            columns={acquisitionColumns}
            getRowHeight={() => "auto"}
            autoHeight
            // pageSizeOptions={[10, 25, 50, 100]}
            // initialState={{
            //   pagination: { paginationModel: { page: 0, pageSize: 10 } },
            // }}
            // getRowClassName={(params) =>
            //   params.indexRelativeToCurrentPage % 2 === 0
            //     ? "Mui-even"
            //     : "Mui-odd"
            // }
            sx={{
              "& .MuiDataGrid-cell": {
                display: "flex",
                alignItems: "flex-start",
                padding: "8px",
                whiteSpace: "normal",
              },
              "& .MuiDataGrid-row": {
                "&.Mui-selected": {
                  backgroundColor: "rgba(25, 118, 210, 0.08)",
                  "&:hover": {
                    backgroundColor: "rgba(25, 118, 210, 0.12)",
                  },
                },
              },
            }}
          /> */}
        </div>

        {/* Legend */}
        {/* <Box>
          <Typography fontWeight="bold">Legend:</Typography>
          <Stack
            direction="row"
            spacing={3}
            mt={1}
            alignItems="center"
            flexWrap="wrap"
          >
            {!isPrintMode && (
              <div style={{ fontSize: "0.85rem", marginTop: "0.5rem" }}>
                <strong>Legend:</strong>
                = Phone Call &nbsp;|&nbsp;
                <span style={{ cursor: "pointer" }}></span> = Recording
                Available (clickable) &nbsp;|&nbsp; = Online Booking
                &nbsp;|&nbsp; = Add/Edit Comment
              </div>
            )}
          </Stack>
        </Box> */}
      </Box>
      {/* <UpdateLostModal
        open={openUpdateLostModal}
        onClose={() => setOpenUpdateLostModal(false)}
        onSave={handleUpdateLost}
        clinicUniqueId={clinicData}
        dateFilter={dateFilter}
        row={selectedLostLead}
        type={type}
        value={value}
        handleChange={handleChange}
        loading={loading}
        showAcquisitionDialog={showAcquisitionDialog}
        setShowAcquisitionDialog={setShowAcquisitionDialog}
        setFormData={setFormData}
        formData={formData}
        handleAcquisitionSubmit={handleAcquisitionSubmit}
      /> */}
      <UpdateOnlineLeads
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        clinicData={clinicDatax}
        dateFilter={dateFilter}
        initialData={selectedRow}
        onSave={fetchLostLeadsData}
        refetchApi={fetchLostLeadsData}
      />

      <UpdateAcquisition
        open={isModalOpenAcquisition}
        onClose={() => setIsModalOpenAcquisition(false)}
        clinicData={clinicDatax}
        dateFilter={dateFilter}
        initialData={selectedRow}
        onSave={fetchLostLeadsData}
      />
      <UpdateCallLeads
        open={openUpdateLostModal}
        onClose={() => setOpenUpdateLostModal(false)}
        clinicData={clinicDatax}
        dateFilter={dateFilter}
        initialData={selectedRow}
        onSave={fetchLostLeadsData}
      />
      <CommentModal
        onClose={() => {
          setOpen1(false);
          setCommentData({});
        }}
        data={commentData}
        open={open1}
        clinicData={clinicData}
        refetchApi={fetchLostLeadsData}
        api="newpatientcomment"
      />
      <CommentModal
        onClose={() => {
          setOpen2(false);
          setCommentData({});
        }}
        data={commentData}
        open={open2}
        clinicData={clinicData}
        refetchApi={fetchLostLeadsData}
        api="callcomment"
      />
      <CommentModal
        onClose={() => {
          setOpen3(false);
          setCommentData({});
        }}
        data={commentData}
        open={open3}
        clinicData={clinicData}
        refetchApi={fetchLostLeadsData}
        api="callcomment"
      />
    </>
  );
};

export default LostLeadsSection;
